export default __webpack_public_path__ + "static/media/ReportIcon-Cell-MS.92582165.jpg";